import api from "../global/Api";
import { ENDPOINTS } from "../global/ApiEndpoints";

// Get All Users
export const getAllUsers = async (page, size) => {
  const response = await api.get(`/${ENDPOINTS.USERS}`, {
    params: { page, size },
  });

  return response.data;
};

// Create User
export const createUser = async (user) => {
  const response = await api.post(`/${ENDPOINTS.USERS}`, user);
  return response.data;
};

// Delete User
export const deleteUser = async (id) => {
  const response = await api.delete(`/${ENDPOINTS.USERS}/${id}`);
  return response.data;
};

// Get info to activate the user account
export const getActivactionAccountByToken = async (id) => {
  const response = await api.get(`/${ENDPOINTS.USERS}/${id}/activation-token`, { skipAuth: true });
  return response.data;
}

// Does the user account activation
export const activateAccount = async (activationAccountRequest) => {
  const response = await api.post(`/${ENDPOINTS.USERS}/active-account`, activationAccountRequest);
  return response.data;
}

// Does the password reset
export const resetPassword = async(resetPasswordRequest)=>{
  const response = await api.post(`/${ENDPOINTS.USERS}/reset-password`, resetPasswordRequest, {skipAuth: true});
  return response.data;
}

